// src/components/dealer/VehicleAvailabilityToggle.js
import React from 'react';

const VehicleAvailabilityToggle = ({ vehicleId, isAvailable, onToggle, disabled = false }) => {
  const handleChange = () => {
    if (!disabled) {
      onToggle(vehicleId, !isAvailable);
    }
  };

  return (
    <button
      type="button"
      onClick={handleChange}
      disabled={disabled}
      className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-app-accent focus:ring-offset-2 focus:ring-offset-gray-900 ${
        disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
      } ${isAvailable ? 'bg-app-success' : 'bg-gray-700'}`}
      aria-label={`Toggle availability for test drives`}
    >
      <span
        className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
          isAvailable ? 'translate-x-6' : 'translate-x-1'
        }`}
      />
    </button>
  );
};

export default VehicleAvailabilityToggle;
